export { actionTypes } from './actions';
export { default as reducer } from './reducer';



// WEBPACK FOOTER //
// ./src/cards/reducers/customization/index.js